import React from "react";
import "../style/Banner.css";
import bannerLogo from "../assets/miamiohUpdated.png";

const Banner = () => {
  return (
    <header className="banner">
      <div className="banner-section banner-left">
        Center for Cybersecurity
      </div>

      <div className="banner-section banner-center">
        Multidisciplinary Pathways to Cybersecurity Professionals
      </div>

      <div className="banner-section banner-right">
        <img
          src={bannerLogo}
          alt="Miami University logo"
          className="banner-image"
        />
      </div>
    </header>
  );
};

export default Banner;
